export const gtm1SocialPostCreator = {
  eventSocialPostCreatorActionHandler ({ data }) {
    const {
      screen_name,
      event_action,
      category_name,
      subcategory_name,
      background_name,
      way_of_adding,
      way_of_adding_notification_id,
      text_choice,
      channel_name,
      were_hashtags_added,
      was_logo_added,
      was_background_changed,
      was_text_edited,
      edit_format,
      are_reviews_available,
      channel_package_name,
      source,
    } = data
    return {
      event: 'Social_Post_Creator_Action',
      properties: {
        screen_name,
        event_action,
        category_name,
        subcategory_name,
        background_name,
        text_choice,
        way_of_adding,
        channel_name,
        were_hashtags_added,
        was_logo_added,
        was_background_changed,
        was_text_edited,
        edit_format,
        are_reviews_available,
        channel_package_name,
        source,
        ...(way_of_adding_notification_id && { way_of_adding_notification_id }),
      },
    }
  },
}
